import { z } from 'zod';
export const GS1_RESOLVER_DESCRIPTION_JSON_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'https://ref.gs1.org/standards/digital-link/resolver-description-schema.json',
    title: 'GS1 Digital Link Resolver Description File',
    type: 'object',
    required: ['name', 'resolverRoot', 'supportedPrimaryKeys'],
    additionalProperties: true,
    properties: {
        $schema: { type: 'string', format: 'uri' },
        name: { type: 'string', minLength: 1 },
        resolverRoot: {
            type: 'string',
            pattern: '^https?://[^/]+(?:/[^/]+)*$',
        },
        supportedPrimaryKeys: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'string',
                pattern: '^(all|[0-9]{2,4})$',
            },
        },
        supportedLinkType: {
            type: 'array',
            items: {
                type: 'object',
                required: ['namespace', 'prefix'],
                properties: {
                    namespace: { type: 'string', format: 'uri' },
                    prefix: { type: 'string', minLength: 1 },
                    url: { type: 'string', format: 'uri' },
                },
            },
        },
        supportedContextValuesEnumerated: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
        },
        supportsSemanticInterpretation: { type: 'boolean' },
        validatesCheckDigits: { type: 'boolean' },
        defaultLinksetMimeType: { type: 'string', minLength: 1 },
    },
};
export const Gs1ResolverDescriptionSchema = z
    .object({
    $schema: z
        .literal('https://ref.gs1.org/standards/digital-link/resolver-description-schema.json')
        .optional(),
    name: z.string().min(1),
    resolverRoot: z
        .string()
        .url()
        .refine((val) => val.startsWith('https://') && !val.endsWith('/'), {
        message: 'resolverRoot must be an https:// origin without trailing slash (GS1 Resolution & Linkset v1.2.1 §3 p.31)',
    }),
    supportedPrimaryKeys: z
        .array(z.string().regex(/^(all|[0-9]{2,4})$/))
        .min(1)
        .readonly(),
    supportedLinkType: z
        .array(z.object({
        namespace: z.string().url(),
        prefix: z.string().min(1),
        url: z.string().url().optional(),
    }))
        .readonly()
        .optional(),
    supportedContextValuesEnumerated: z.array(z.string().min(1)).readonly().optional(),
    supportsSemanticInterpretation: z.boolean().optional(),
    validatesCheckDigits: z.boolean().optional(),
    defaultLinksetMimeType: z.string().min(1).optional(),
})
    .passthrough();
export const API_CLIENT_SCOPES = [
    'identifiers:read',
    'identifiers:write',
    'qualifiers:read',
    'qualifiers:write',
    'recalls:write',
    'recall:write',
    'domains:read',
    'domains:write',
    'analytics:read',
    'analytics:write',
    'webhooks:read',
    'webhooks:write',
    'webhooks:manage',
    'myplayer:sync',
];
//# sourceMappingURL=firestore-schemas.js.map